export default __webpack_public_path__ + "static/media/Ham.47218279.jpg";